import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import FileUpload from './FileUpload';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { v4 as uuidv4 } from 'uuid';
import GeneralizedModal from './GeneralizedModal';
// import ProfileModal from './ProfileModal';
import logo from './logo.svg';
import { dotStream } from 'ldrs'
import { Rnd } from 'react-rnd';
import openFloatingModal from './openFloatingModal';
import MobileLandscapePrompt from "./MobileLandscapePrompt";

function App() {
  const logoRef = useRef(null);
  const selectedStudentIdRef = useRef(null);
  const dataSectionToRender = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const profileModalOpen = useRef();
  // var [academyData, setAcademyData] = useState({});
  const academyData = useRef([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const processKeyRef = useRef(uuidv4());
  console.log(processKeyRef);
 
   

  // const isModalOpen = useRef(false);
  const openProfileModal = () => setIsProfileModalOpen(true);
  const closeProfileModal = () => setIsProfileModalOpen(false);
  const openLoadingModal = () =>  {
    var htmlString = `
    <div id="loading_content_id" class="modal-overlay">
        <div>
          <div id="loading_content">
          </div>
        </div>
      </div>`;
      document.getElementById('loading-modal-content').innerHTML = htmlString;
      const studentRoot = ReactDOM.createRoot( document.getElementById('loading_content'));
      studentRoot.render(<div className="ultimateCenter">
        <h4>Loading</h4>
        <l-dot-stream
        size="150"
        speed="2.0"
        color="black" 
        ></l-dot-stream>
    </div>);
      document.getElementById("loading-modal-content").style.display = "inline";
  };
  const closeLoadingModal = () => {
    document.getElementById('loading-modal-content').style.display = 'none';
  };
// helper (put near your component)
  const openHtmlDocModal = (url, title) =>
    openFloatingModal(
      title,
      <iframe
        src={url}
        title={title}
        style={{ width: '100%', height: '70vh', border: 0 }}
      />
    );

  const divs = [
    { id: 'profile-modal-content', label: 'Profile Content' },
    { id: 'forecast-table-modal-content', label: 'Forecast Table' },
    { id: 'forecast-charts-modal-content', label: 'Forecast Charts' },
    { id: 'class-statics-modal-content', label: 'Class Statics' },
    { id: 'class-table-modal-content', label: 'Class Table' },
    { id: 'tutor-modal-content', label: 'Tutor Modal' },
    { id: 'social-modal-content', label: 'Social Modal' },
    { id: 'grade-report-modal-content', label: 'Grade Report Modal' },
    { id: 'loading-modal-content', label: 'Loading Modal' },
  ];
  // put near top of your file
  const popper_cfg = {
    strategy: 'fixed',
    modifiers: [
      { name: 'preventOverflow', options: { boundary: 'viewport', altBoundary: true } },
      { name: 'computeStyles', options: { adaptive: false } }, // avoids translate/transform jumps
    ],
  };
  // // inside App()
  // const navContent = (
  //   <Navbar.Offcanvas
  //     id="app-nav-offcanvas"
  //     aria-labelledby="app-nav-offcanvas-label"
  //     placement="end"   // right-side drawer
  //     className="bg-dark text-white d-lg-none"
  //   >
  //     <Offcanvas.Header closeButton closeVariant="white">
  //       <Offcanvas.Title id="app-nav-offcanvas-label">
  //         📊 Dashboards
  //       </Offcanvas.Title>
  //     </Offcanvas.Header>
  
  //     <Offcanvas.Body
  //       className="bg-dark d-flex flex-column gap-4"
  //       style={{ padding: "1rem" }}
  //     >
  //       {/* Student Summary */}
  //       <div className="d-grid gap-2">
  //         <h6 className="text-white-50">Student Summary</h6>
  //         <Button
  //           className="w-100 text-start"
  //           style={{ background: "linear-gradient(135deg,#1d1160,rgb(73, 9, 169))", border: "none" }}
  //           onClick={() => {
  //             setIsLoading(true);
  //             openFloatingModal('Student Summary', academyData.current.studentDataTable);
  //             setIsLoading(false);
  //           }}
  //         >
  //           Student Summary
  //         </Button>
  //       </div>
  
  //       {/* Demographics */}
  //       <div className="d-grid gap-2">
  //         <h6 className="text-white-50">Overall Demographics</h6>
  //         <Button
  //           className="w-100 text-start"
  //           onClick={() => openFloatingModal('Full Student Chart Data', academyData.current.fullStudentChartData)}
  //         >
  //           Demographic Charts
  //         </Button>
  //         <Button
  //           className="w-100 text-start"
  //           onClick={() => openFloatingModal('Student Statistics', academyData.current.statisticsChart)}
  //         >
  //           Performance Statistics
  //         </Button>
  //       </div>
  
  //       {/* New Students */}
  //       <div className="d-grid gap-2">
  //         <h6 className="text-white-50">New Students</h6>
  //         <Button
  //           className="w-100 text-start"
  //           onClick={() => openFloatingModal('Forecast Table', academyData.current.forecastFinal)}
  //         >
  //           Forecast Table
  //         </Button>
  //         <Button
  //           className="w-100 text-start"
  //           onClick={() => openFloatingModal('Forecast Charts', academyData.current.forecastChart)}
  //         >
  //           Forecast Charts
  //         </Button>
  //       </div>
  
  //       {/* Class Data */}
  //       <div className="d-grid gap-2">
  //         <h6 className="text-white-50">Class Data</h6>
  //         <Button
  //           className="w-100 text-start"
  //           onClick={() => openFloatingModal('Class Statistics', academyData.current.classStatisticsFinal)}
  //         >
  //           Class Statistics
  //         </Button>
  //         <Button
  //           className="w-100 text-start"
  //           onClick={() => openFloatingModal('Class Table', academyData.current.classTableFinal)}
  //         >
  //           Class Table
  //         </Button>
  //       </div>
  
  //       {/* Additional Insights */}
  //       <div className="d-grid gap-2">
  //         <h6 className="text-white-50">Additional Insights</h6>
  //         <Button
  //           className="w-100 text-start"
  //           onClick={() => openFloatingModal('Tutor Center', academyData.current.tutorChart)}
  //         >
  //           Tutor Center
  //         </Button>
  //         <Button
  //           className="w-100 text-start"
  //           onClick={() => openFloatingModal('Social Analysis', academyData.current.graphData)}
  //         >
  //           Social Analysis
  //         </Button>
  //         <Button
  //           className="w-100 text-start"
  //           onClick={() => openFloatingModal('Grade Report Analysis', academyData.current.gradeReport)}
  //         >
  //           Grade Report Analysis
  //         </Button>
  //       </div>
  
  //       {/* Compliance */}
  //       <div className="d-grid gap-2">
  //         <h6 className="text-white-50">Compliance</h6>
  //         <Button
  //           className="w-100 text-start text-black"
  //           style={{ background: "linear-gradient(135deg, #f8f8f8, #cfcfcf)", border: "none" }}
  //           onClick={() => openHtmlDocModal('/ferpa.html', 'FERPA Compliance')}
  //         >
  //           FERPA Compliance
  //         </Button>
  //         <Button
  //           className="w-100 text-start text-black"
  //           style={{ background: "linear-gradient(135deg, #f8f8f8, #cfcfcf)", border: "none" }}
  //           onClick={() => openHtmlDocModal('/coppa.html', 'COPPA Compliance')}
  //         >
  //           COPPA Compliance
  //         </Button>
  //         <Button
  //           className="w-100 text-start text-black"
  //           style={{ background: "linear-gradient(135deg, #f8f8f8, #cfcfcf)", border: "none" }}
  //           onClick={() => openHtmlDocModal('/privacy.html', 'Privacy Policy')}
  //         >
  //           Privacy Policy
  //         </Button>
  //         <Button
  //           className="w-100 text-start text-black"
  //           style={{ background: "linear-gradient(135deg, #f8f8f8, #cfcfcf)", border: "none" }}
  //           onClick={() => openHtmlDocModal('/data-handling.html', 'Data Handling')}
  //         >
  //           Data Handling
  //         </Button>
  //       </div>
  //     </Offcanvas.Body>
  //   </Navbar.Offcanvas>
  // );
  
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 992) setShowDrawer(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  useEffect(() => {
      if (isLoading) {
          document.body.style.cursor = 'wait';
      } else {
          document.body.style.cursor = 'default';
      }
      return () => {
          document.body.style.cursor = 'default'; // Cleanup
      };
  }, [isLoading]);
  return (
    <>
    <MobileLandscapePrompt appSelector="#root" />
    <div key='app' className="App">

      {/* <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginTop: '40px'}}>
          <div id="profile-modal-content"></div>
          <div id="forecast-table-modal-content"></div>
          <div id="forecast-charts-modal-content"></div>
          <div id="class-statics-modal-content"></div>
          <div id="class-table-modal-content"></div>
          <div id="tutor-modal-content"></div>
          <div id="social-modal-content"></div>
          <div id="grade-report-modal-content"></div>
          <div id="loading-modal-content"></div>
        </div> */}
    </div>
    <FileUpload setIsLoading={setIsLoading} processKeyRef={processKeyRef} profileModalOpen={profileModalOpen} closeProfileModal={closeProfileModal} academyData={academyData} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} selectedStudentIdRef={selectedStudentIdRef} dataSectionToRender={dataSectionToRender} key="FileUpload"/>
    <GeneralizedModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        dataSectionToRender={dataSectionToRender}
        academyData={academyData}
        selectedStudentIdRef={selectedStudentIdRef}
    />

    {/* <ProfileModal
        profileModalOpen={profileModalOpen}
        closeProfileModal={closeProfileModal}
        isProfileModalOpen={isProfileModalOpen}
        setIsProfileModalOpen={setIsProfileModalOpen}
        dataSectionToRender={dataSectionToRender}
        academyData={academyData}
        selectedStudentIdRef={selectedStudentIdRef}
    /> */}
    </>
  );
}

export default App;
